//region globals
var map,dealerLocatorDealers = [];
var userLat, userLong;

// Global variables to hold the cluster groups and the overall container
var provinceClusterGroups = {};
var cityClusterGroups = {};
var dealerMarkers = {};
var provinceLayer = L.layerGroup(); 
var cityLayer = L.layerGroup();

// Use a LayerGroup to manage all clusters, making it easier to clear the map.
var allClustersLayerGroup = L.layerGroup(); 

// Define the zoom level where the switch occurs (e.g., 8)
const CLUSTER_SWITCH_ZOOM = 6;

//defined global autocomplete
var autcompleteObject

//endregion

//main entry
navigator.geolocation.getCurrentPosition(
    //called when location services are allowed
    function(location) {   
        userLat = location.coords.latitude
        userLong = location.coords.longitude
        initMap({lat:userLat, long:userLong})
    }, 
    //called when location services are blocked
    function(){
        initMap()
    }
);

async function initMap(initialCoordinates, label){
    if (map) {
        map.off();
        map.remove();
    }
    if(!label){
        label = "Your Location"
    }

    document.body.dispatchEvent(new CustomEvent("processStop"));    
    
    if(initialCoordinates){
        var lat = initialCoordinates.lat,
        lng = initialCoordinates.long;

        map = L.map("mapDiv").setView([lat, lng], 10);

        L.easyButton('<img width="18px" src="https://www.gammasales.com/img/icons/house.png">', function (btn, mapRef) {
            mapRef.setView([lat, lng], 10);
            const homeMarker = document.querySelector(`img[title="${label}"]`);
            if(homeMarker) homeMarker.click();
        }, "Zoom To Home").addTo(map);

        L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
            attribution: 'Map data © <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors',
            maxZoom: 18
        }).addTo(map);

        var homeIcon = L.icon({
            iconUrl: "https://www.gammasales.com/img/icons/map-pin.png",
            iconSize: [20, 30]
        });

        var marker = L.marker([lat, lng], {
            icon: homeIcon,
            title: label
        }).addTo(map);

        marker.bindPopup(label);
        marker.on("mouseover", function () {
            this.openPopup();
        });
        marker.on("mouseout", function () {
            this.closePopup();
        });
    }else{
        map = L.map("mapDiv").setView([56.89250354776512, -90.52347130472883], 3);
        L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
            attribution: 'Map data © <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors',
            maxZoom: 18
        }).addTo(map);
    }
    

    await addAllDealersToMap()
    toggleLoading(false)
}

async function getAllDealerCoordinates(){
    var url = 'https://integrations.gammapowersports.com/shopifyWebhook/getDealers/FLY?storeCode=FRC'
    var response = await fetch(url)
    var data = await response.json()        
    return data.dealers        
}

async function addAllDealersToMap(){
    var dealerCoordinates = dealerLocatorDealers && dealerLocatorDealers.length ? dealerLocatorDealers : await getAllDealerCoordinates()
    for(var dealerCoordinate of dealerCoordinates){
        if(!dealerCoordinate.distanceTo){
            dealerCoordinate.distanceTo = haversineDistance([userLat,userLong], [dealerCoordinate.customerCoordinate.latitude,dealerCoordinate.customerCoordinate.longitude])
        }
        dealerCoordinate.shipTo.autocompleteKey = buildAutocompleteKeyForDealer(dealerCoordinate)
    }
    if(dealerCoordinates[0].distanceTo){
        dealerCoordinates.sort(function(a, b) { 
            return a.distanceTo - b.distanceTo;
        })
    }else{        
        dealerCoordinates.sort(function(a, b) { 
            return a.shipTo.customerName.localeCompare(b.shipTo.customerName);
        })
    }    
    updateResults(dealerCoordinates, false);

    //intialize the autocomplete
    var placeholderMessage = dealerLocatorPlaceholderMessage || "Enter a dealer name or address" //dealerLocatorPlaceholderMessage comes from the template, cannot pull translations into js
    autcompleteObject = enableAutocomplete(
        "#inpage-search-param",
        placeholderMessage,
        dealerLocatorDealers.map(function(it){return it.shipTo}),        
        ['autocompleteKey'],
        'customerName',
        dealerAutocompleteItemClicked
    )
}

function updateResults(dealers, mapOnly) {
    if (mapOnly == undefined) {
        mapOnly = false
    }

    var tbody = document.querySelector("#results-table > tbody");
    if (!mapOnly) {
        tbody.innerHTML = "";
    }
    dealerLocatorDealers = dealers;

    // 1. Create two master containers (LayerGroups) 
    // These will act as the switches we toggle on/off the map
    const allProvincesLayer = L.layerGroup();
    const allCitiesLayer = L.layerGroup();

    // Clear previous references if they exist globally
    // (Assuming you have global vars for these, if not, declare them above)
    if (window.currentProvinceLayer && map.hasLayer(window.currentProvinceLayer)) map.removeLayer(window.currentProvinceLayer);
    if (window.currentCityLayer && map.hasLayer(window.currentCityLayer)) map.removeLayer(window.currentCityLayer);

    // Group dealers by Province -> City
    const groupedDealers = dealers.reduce((acc, dealer) => {
        const provinceKey = dealer.shipTo.province ? dealer.shipTo.province.toUpperCase() : 'UNKNOWN_PROVINCE';
        const cityKey = dealer.shipTo.city ? dealer.shipTo.city.toUpperCase() : 'UNKNOWN_CITY';

        if (!acc[provinceKey]) acc[provinceKey] = {};
        if (!acc[provinceKey][cityKey]) acc[provinceKey][cityKey] = [];
        
        acc[provinceKey][cityKey].push(dealer);
        return acc;
    }, {});

    dealerMarkers = {}; // Reset global marker lookup

    // Helper: Creates a marker with all events attached
    // We need this because we have to create TWO markers per dealer (one for each layer)
    function createDealerMarker(dealer) {
        let marker = L.marker([dealer.customerCoordinate.latitude, dealer.customerCoordinate.longitude], {
            title: dealer.shipTo.shipToName
        });
        
        marker.dealer = dealer;
        marker.bindPopup(`
            <div class="map-tooltip">
                <p><b>${dealer.shipTo.locationName}</b></p>
                <p class="unmargined">${dealer.shipTo.address1}, ${dealer.shipTo.city} ${dealer.shipTo.province}, ${dealer.shipTo.postalCode}</p>
                ${dealer.distanceTo ? `<p class="unmargined"><b>${dealer.distanceTo.toFixed(1)} km</b></p>` : ""}
            </div>
        `);

        marker.on("mouseover", function () { this.openPopup(); });
        marker.on("mouseout", function () { this.closePopup(); });
        marker.on("click", function () {
            console.log("Marker clicked...")
            console.log(this.dealer)
            var myElement = document.getElementById(this.dealer.shipTo.customer + '-' + this.dealer.shipTo.shipTo);
            console.log(myElement)
            const container = document.getElementById("results-table").parentElement.parentElement;
            if(myElement && container) {
                const topPos = myElement.offsetTop;
                container.scrollTo({ top: topPos, behavior: 'instant' });
            }
        });
        
        return marker;
    }

    // Loop through Provinces
    for (const province in groupedDealers) {
        // A. Create the Province Cluster
        const provinceCluster = L.markerClusterGroup({
            chunkedLoading: true,
            chunkInterval: 50,
            chunkSize: 50
        });

        // Tooltip for Province Name
        provinceCluster.on('clustermouseover', function (a) {
            a.layer.bindTooltip(province).openTooltip();
        });

        // Loop through Cities within this Province
        for (const city in groupedDealers[province]) {
            
            // B. Create the City Cluster
            // Note: maxZoom logic is handled by our custom switcher now, 
            // but we keep settings consistent.
            const cityCluster = L.markerClusterGroup({
                chunkedLoading: true,
                chunkInterval: 50,
                chunkSize: 50
            });

            // Tooltip for City Name
            cityCluster.on('clustermouseover', function (a) {
                a.layer.bindTooltip(city).openTooltip();
            });

            // Add Markers
            groupedDealers[province][city].forEach(dealer => {
                // 1. Create marker for Province Layer and add to Province Cluster
                const pMarker = createDealerMarker(dealer);
                provinceCluster.addLayer(pMarker);

                // 2. Create marker for City Layer and add to City Cluster
                const cMarker = createDealerMarker(dealer);
                cityCluster.addLayer(cMarker);
                
                // Keep a reference to one of them for external use if needed
                dealerMarkers[dealers.indexOf(dealer)] = cMarker;
            });

            // Add the filled City Cluster to the Master City Layer
            allCitiesLayer.addLayer(cityCluster);
        }

        // Add the filled Province Cluster to the Master Province Layer
        // Notice: We are NOT adding cityCluster to provinceCluster here. They are siblings.
        allProvincesLayer.addLayer(provinceCluster);
    }

    // Save references globally so we can remove them later
    window.currentProvinceLayer = allProvincesLayer;
    window.currentCityLayer = allCitiesLayer;

    // 2. The Switcher Logic
    function updateClusterVisibility() {
        const currentZoom = map.getZoom();
        
        if (currentZoom >= CLUSTER_SWITCH_ZOOM) {            
            if (map.hasLayer(allProvincesLayer)) {
                map.removeLayer(allProvincesLayer);
            }
            if (!map.hasLayer(allCitiesLayer)) {
                map.addLayer(allCitiesLayer);
            }
        } else {            
            if (map.hasLayer(allCitiesLayer)) {
                map.removeLayer(allCitiesLayer);
            }
            if (!map.hasLayer(allProvincesLayer)) {
                map.addLayer(allProvincesLayer);
            }
        }
    }

    // Attach zoom listener
    map.off('zoomend', updateClusterVisibility);
    map.on('zoomend', updateClusterVisibility);
    
    // Initial check to render correct layer immediately
    updateClusterVisibility();

    // --- Table Row Insertion ---
    if (!mapOnly) {
        dealers.forEach(dealer => {
            tbody.insertAdjacentHTML('beforeend', createRowFromDealer(dealer));
        });
    }
}

function createRowFromDealer(d) {
    // Determine dealer types for images
    const type = d.shipTo.dealerType || "";
    const isAll = type.includes("ALL");
    const isSnow = isAll || type.includes("S");
    const isAtv = isAll || (type.includes("+A") || type.includes("A+"));
    const isMoto = isAll || type.includes("M");

    let typeImages = "";
    if (isSnow) typeImages += "<img class='inline-div dealer-type-img' title='Snow Dealer' src='https://fitment.gammapowersports.com/fitment-app/static/images/icons/snowmobile.png'> ";
    if (isAtv) typeImages += "<img class='inline-div dealer-type-img' title='ATV Dealer' src='https://fitment.gammapowersports.com/fitment-app/static/images/icons/atv.png'> ";
    if (isMoto) typeImages += "<img class='inline-div dealer-type-img' title='Motorcycle Dealer' src='https://fitment.gammapowersports.com/fitment-app/static/images/icons/motorcycle.png'>";

    // Determine type string
    let typeString = "Gamma Parts & Accessories";
    if (type === "ALL") typeString = "Snow, Motorcycle, ATV and PWC Parts & Accessories";
    else if (type === "M+A") typeString = "Motorcycle and ATV Parts & Accessories";
    else if (type === "A+S") typeString = "Snowmobile and ATV Parts & Accessories";
    else if (type === "M+S") typeString = "Motorcycle and Snowmobile Parts & Accessories";
    else if (type === "ATV") typeString = "ATV Parts & Accessories";
    else if (type === "SNOW") typeString = "Snowmobile Parts & Accessories";
    else if (type === "MC") typeString = "Motorcycle Parts & Accessories";

    return `<tr id="${d.shipTo.customer}-${d.shipTo.shipTo}">
        <td class="unpadded result-list-item">
            <div class="dealer-card">
                
                <!-- Dealer Name and Distance (Using grid for horizontal layout) -->
                <div class="grid grid-gutterless">
                    <!-- Name (two-thirds) -->
                    <div class="grid__item two-thirds">
                        <p style="margin: 0;"><b>${d.shipTo.locationName}</b></p>
                    </div>
                    <!-- Distance (one-third, right-aligned) -->
                    ${d.distanceTo ? `
                    <div class="grid__item one-third text-right">
                        <p class="distance-val" style="margin: 0;">${d.distanceTo.toFixed(1)} km</p>
                    </div>    
                    `:""}
                    
                </div>

                <!-- Address (Single row, centered text) -->
                <div class="text-center" style="margin-top: 5px;">
                    <p style="margin: 0; font-size: 13px;">${d.shipTo.address1}, ${d.shipTo.city} ${d.shipTo.province}, ${d.shipTo.postalCode}</p>
                </div>
                
                <!-- Phone Number (Single row, centered text) -->
                <div class="text-center" style="margin-top: 5px;">
                    <a href="tel:${d.shipTo.phoneNumber}">${d.shipTo.phoneNumber}</a>
                </div>                

                <!-- Action Links (Right-aligned using grid/text-right) -->
                <div class="grid grid-gutterless" style="margin-top: 10px;">
                    <div class="grid__item one-whole text-right">
                        <a class="text-link" ${d.shipTo.website ? "" : "hidden"} target="_blank" href='http://${d.shipTo.website}'>Website</a>
                        <a class="text-link" target="_blank" href="https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(`${d.shipTo.address1}, ${d.shipTo.city} ${d.shipTo.province}, ${d.shipTo.postalCode}`)}" style="margin-left: 10px;"> Directions </a>
                        <a class="text-link map-link" href="javascript:void(0)" onclick="dealerRowClicked(${dealerLocatorDealers.indexOf(d)})" style="margin-left: 10px;"> Map </a>
                    </div>
                </div>

            </div>
        </td>
    </tr>`    
}

function dealerRowClicked(index) {
    var d = dealerLocatorDealers[index];

    // 1. Get the stored marker object
    const targetMarker = dealerMarkers[index];

    if (targetMarker) {
        // Find the correct cluster group to call the method on.
        // We need one of the L.markerClusterGroup instances that contains this marker.
        // Since we added all markers to the Province Cluster Group, we can grab it based on the dealer's province.
        const provinceKey = d.shipTo.province ? d.shipTo.province.toUpperCase() : 'UNKNOWN_PROVINCE';
        const clusterGroup = provinceClusterGroups[provinceKey];

        if (clusterGroup) {
            // 2. Zoom to the marker and ensure it is visible (unclustered)
            clusterGroup.zoomToShowLayer(targetMarker, function () {
                // 3. Pan the map to the final location
                map.panTo([d.customerCoordinate.latitude, d.customerCoordinate.longitude]);
                
                // 4. Open the marker's popup
                targetMarker.openPopup();
            });
        } else {
            // Fallback if the marker isn't in a cluster group (shouldn't happen with the current setup)
            map.setView([d.customerCoordinate.latitude, d.customerCoordinate.longitude], 15);
            targetMarker.openPopup();
        }
    } else {
        // Fallback to simple pan if the marker wasn't stored
        map.panTo([d.customerCoordinate.latitude, d.customerCoordinate.longitude], 15);
    }
}

async function validateInpageInput(e) {
    if (e) {
        e.preventDefault();
        e.stopPropagation();
    }
    toggleLoading(true)

    const inpageSearchParam = document.getElementById("inpage-search-param");    
    var searchTerm = inpageSearchParam.value
    var alertEl = document.querySelector("#page-message")

    alertEl.classList.add("hide")    
    autcompleteObject.close();
    var results = await geocodeAddressRateLimited(searchTerm)
    console.log(results)
    if(results && results.length){        
        var label         
        if(results[0].address && results[0].addresstype && results[0].address[results[0].addresstype] ){
            label = results[0].address[results[0].addresstype]
        }
        zoomToBoundingBox(map, results[0].boundingbox)        
    }else{
        var pageMessage = `'${searchTerm}' not recognized as an address. Please enter a valid address or select a specific dealer.`        
        alertEl.innerText = pageMessage
        alertEl.classList.remove("hide")
    }

    toggleLoading(false)
}

//region autocomplete stuff

function dealerAutocompleteItemClicked(resultItem){    
    var alertEl = document.querySelector("#page-message")
    alertEl.classList.add("hide")    

    var shipTo = resultItem.value    
    var myElement = document.getElementById(shipTo.customer + '-' + shipTo.shipTo);    
    const container = document.getElementById("results-table").parentElement.parentElement;
    if(myElement && container) {
        const topPos = myElement.offsetTop;
        container.scrollTo({ top: topPos, behavior: 'instant' });
        myElement.querySelector(".map-link").click()
    }
}

function enableAutocomplete(selector, placeholder, options, keys, displayKey, selectCallback){
    var config = {
        selector: selector,
        placeHolder: placeholder,
        data: {
            src: options?options:[],                
            cache: true,
        },
        resultsList: {
            element: (list, data) => {
                if (!data.results.length) {                        
                    const message = document.createElement("div");                        
                    message.setAttribute("class", "no_result");                        
                    message.innerHTML = `<span>Found No Results for "${data.query}"</span>`;                        
                    list.prepend(message);
                }
            },
            noResults: false,
            maxResults: 100
        },        
        resultItem: {
            highlight: true,
            element: (item, data) => {                
                if (displayKey) {                                        
                    const displayValue = data.value[displayKey];                    
                    item.innerHTML = `
                        <span class="autocomplete-item">
                            ${displayValue}<br>
                            <span class='autocomplete-address'>${data.value.address1}, ${data.value.city}, ${data.value.province} ${data.value.postalCode}</span>
                        </span>
                    `;
                    item.innerHTML = applyHighlighting(item.innerHTML, autcompleteObject.input.value)
                } else {                    
                    item.innerHTML = `<span>${data.value}</span>`;
                }
            }
        },
        events: {
            input: {
                selection: async (event) => {                        
                    const selection = keys ? event.detail.selection.value[displayKey]: event.detail.selection.value;
                    event.srcElement.value = selection;

                    if(typeof selectCallback == 'function'){
                        await selectCallback(event.detail.selection)
                    }
                }
            }
        },
        trigger: (query) =>{
            return true
        },
        submit: true
    }       
    
    if(keys){
        config.data.keys = keys
    }
    
    var autoCompleteJS = new autoComplete(config);
    //this.data.autocompleteObjects[identifier] = autoCompleteJS;

    //add extra event listeners
    var inputElement = document.querySelector(selector);
    inputElement.addEventListener('focusin',this.handleAutocompleteFocus);
    inputElement.addEventListener('selection', this.handleAutocompleteSelection)  

    return autoCompleteJS
}

function buildAutocompleteKeyForDealer(dealerCoordinate){
    return `${dealerCoordinate.shipTo.city} ${dealerCoordinate.shipTo.postalCode} ${dealerCoordinate.shipTo.city} ${dealerCoordinate.shipTo.address1} ${dealerCoordinate.shipTo.customerName}`
}

const applyHighlighting = (text, query) => {
    if (!text || !query) return text;

    const q = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // escape regex
    const regex = new RegExp(q, 'gi');

    let result = '';
    let buffer = '';
    let insideTag = false;

    for (let i = 0; i < text.length; i++) {
        const char = text[i];

        if (char === '<') {
            // Flush and highlight text accumulated *outside* tags
            if (buffer) {
                buffer = buffer.replace(regex, match =>
                    `<mark class="autoComplete_highlighted">${match}</mark>`
                );
                result += buffer;
                buffer = '';
            }
            insideTag = true;
            result += char;
        } else if (char === '>') {
            insideTag = false;
            result += char;
        } else {
            if (insideTag) {
                // Pass tag content through untouched
                result += char;
            } else {
                // Accumulate text for highlighting
                buffer += char;
            }
        }
    }

    // Flush any remaining buffer
    if (buffer) {
        buffer = buffer.replace(regex, match =>
            `<mark class="autoComplete_highlighted">${match}</mark>`
        );
        result += buffer;
    }

    return result;
};

//endregion

//region utilty methods

// Helper for fade animations to mimic jQuery behavior
const FadeUtils = {
    fadeIn: (element, duration = 400, callback) => {
        if (!element) return;
        element.style.opacity = 0;
        element.style.display = ''; // Reset display to default (block/flex/etc)
        element.style.visibility = 'visible';
        
        let start = null;
        function step(timestamp) {
            if (!start) start = timestamp;
            const progress = timestamp - start;
            element.style.opacity = Math.min(progress / duration, 1);
            if (progress < duration) {
                window.requestAnimationFrame(step);
            } else {
                if (callback) callback();
            }
        }
        window.requestAnimationFrame(step);
    },
    fadeOut: (element, duration = 400, callback) => {
        if (!element) return;
        element.style.opacity = 1;
        
        let start = null;
        function step(timestamp) {
            if (!start) start = timestamp;
            const progress = timestamp - start;
            element.style.opacity = Math.max(1 - (progress / duration), 0);
            if (progress < duration) {
                window.requestAnimationFrame(step);
            } else {
                element.style.display = 'none';
                if (callback) callback();
            }
        }
        window.requestAnimationFrame(step);
    }
};

const haversineDistance = ([lat1, lon1], [lat2, lon2], isMiles = false) => {
    const toRadian = angle => (Math.PI / 180) * angle;
    const distance = (a, b) => (Math.PI / 180) * (a - b);
    const RADIUS_OF_EARTH_IN_KM = 6371;

    const dLat = distance(lat2, lat1);
    const dLon = distance(lon2, lon1);

    lat1 = toRadian(lat1);
    lat2 = toRadian(lat2);

    // Haversine Formula
    const a =
    Math.pow(Math.sin(dLat / 2), 2) +
    Math.pow(Math.sin(dLon / 2), 2) * Math.cos(lat1) * Math.cos(lat2);
    const c = 2 * Math.asin(Math.sqrt(a));

    let finalDistance = RADIUS_OF_EARTH_IN_KM * c;

    if (isMiles) {
    finalDistance /= 1.60934;
    }

    return finalDistance;
};

function toggleLoading(enabled){
    var mainContainer = document.querySelector(".loading-container")
    var spinner = mainContainer.querySelector("#loading-indicator")
    var loadContainer = mainContainer.querySelector(".result-wrapper")
    if(enabled){        
        spinner.classList.remove("spinner-hidden")
        loadContainer.classList.add("is-loading")
    }else{
        spinner.classList.add("spinner-hidden")
        loadContainer.classList.remove("is-loading")
    }
}

const geocodeAddressRateLimited = (function() {
    let lastNominatimRequestTime = 0;
    const MIN_INTERVAL_MS = 1000;

    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    async function geocode(address) {
        // Calculate required wait time based on the state maintained by the closure.
        const timeToWait = MIN_INTERVAL_MS - (Date.now() - lastNominatimRequestTime);

        if (timeToWait > 0) {
            console.log(`Waiting for ${timeToWait}ms to respect the Nominatim rate limit...`);
            await sleep(timeToWait);
        }

        const baseUrl = 'https://nominatim.openstreetmap.org/search';
        const params = new URLSearchParams({
            q: address, 
            format: 'json', 
            addressdetails: 1, 
            limit: 1, 
            'accept-language': 'en' ,
            countrycodes: "ca"
        });

        const url = `${baseUrl}?${params.toString()}`;

        // REQUIRED by Nominatim policy
        const headers = {
            'User-Agent': 'FlyRacingDealerLocator (it@gammapowersports.com)'
        };

        try {
            const response = await fetch(url, { headers });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            
            // Update the state for the next call.
            lastNominatimRequestTime = Date.now();
            
            return data;

        } catch (error) {
            console.error('Geocoding failed:', error);
            throw error; 
        }
    }

    // Returns the rate-limited function.
    return geocode;
})();

function zoomToBoundingBox(map, boundingBox) {    
    const [lat_south, lat_north, lon_west, lon_east] = boundingBox.map(Number);

    
    const southWest = L.latLng(lat_south, lon_west);
    const northEast = L.latLng(lat_north, lon_east);
    
    const bounds = L.latLngBounds(southWest, northEast);
    
    map.fitBounds(bounds, {
        padding: [20, 20] // 20 pixels of padding on all sides
    });
}
//endregion utility methods

// Polyfill for toggleAttribute if needed for very old browsers (though modern browsers support it)
if (!Element.prototype.toggleAttribute) {
    Element.prototype.toggleAttribute = function (name, force) {
        if (force !== undefined) force = !!force;
        if (this.hasAttribute(name)) {
            if (force) return true;
            this.removeAttribute(name);
            return false;
        }
        if (force === false) return false;
        this.setAttribute(name, "");
        return true;
    };
}